type Config = {
  apiUrl: string;
  idpUrl: string;
  tileUrl: string;
  clientId: string;
};

export function getConfig(): Config {
  return {
    apiUrl: import.meta.env.VITE_API_URI,
    idpUrl: import.meta.env.VITE_IDP_URI,
    tileUrl: import.meta.env.VITE_TILE_URL,
    clientId: 'ciam-ui',
  };
}
